import styled from 'styled-components'

import { Flex } from '@h2/components/layout/flex'

const Actions = styled(Flex)`
  justify-content: flex-end;

  > button {
    min-width: 100px;
  }
`
const Form = styled.form`
  > div:nth-child(n + 2) {
    margin-top: 15px;
  }

  > ${Actions}:last-child {
    margin-top: 30px;
  }
`

export { Actions, Form }
